import { Route, Routes } from 'react-router-dom';
import { ManageKYC } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/ManageKYC';
import { ReviewKycWorkflow } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/ReviewKycWorkflow/page/ReviewKycWorkflow';
import { KycPermissions } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/component/KycPermissions';

export const ManageKYCLayout = () => {
	return (
		<KycPermissions>
			<Routes>
				<Route path="/*" element={<ManageKYC />} />
				<Route path="/main/:investorId" element={<ReviewKycWorkflow />} />
			</Routes>
		</KycPermissions>
	);
};
